<template>
    <div class="user_rsv_history">
        <div class="user_rsv_history_title">
            <div class="txt">
                <div class="title_s">{{ $t('popup_user_reservation.label_appointment_history') }}</div>
                <div class="lgray_txt"><small>{{ $t('popup_user_reservation.label_appointment_history_description') }}</small></div>
            </div>
            <div class="btn_switch_wrap dgray small" style="width: 70px;">
                <a class="switch" :class="{'on': isTable}" @click="action_Table"><v-icon small>mdi-format-list-bulleted</v-icon></a>
                <a class="switch" :class="{'on': isCalendar}" @click="action_Calendar"><v-icon small>mdi-calendar</v-icon></a>
            </div>
        </div>
        <ReservationHistoryTable v-show="isTable"
            :reservations="reservations"
            :selectedReservationID="selectedReservationID"
            :isLoading="isHistoryLoading"
            @setSelectedReservationID="handleSetSelectedReservationID"
            @showReservationChangeHistory="handleShowReservationChangeHistory"
            @hideReservationChangeHistory="handleHideReservationChangeHistory"
        />
        <ReservationHistoryCalendar v-show="isCalendar"
            :hservice="hservice"
            :note="note"
            :reservations="reservations"
            :isShow="isCalendar"
            @setSelectedReservationID="handleSetSelectedReservationID"
        />
        <div class="btn_wrap right">
            <button class="btn btn_blue_line btn_m" v-if="isSelectedReservation" @click="action_SelectReservation">{{ $t('popup_user_reservation.button_book_with_selection') }}</button>
            <button class="btn btn_blue btn_m" v-if="isShowNewReservation" @click="action_NewReservation">{{ $t('popup_user_reservation.button_book_new_appointment') }}</button>
        </div>
    </div>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import ReservationHistoryTable from './ReservationHistoryTable.vue'
import ReservationHistoryCalendar from './ReservationHistoryCalendar.vue'

import { closeAlertPopup } from '../../../../../sheet-alert'
import { closePopup, sheetOverlays } from '../../../../../sheet-overlays'
import { reservationSelection, setTimeSelectMode } from '../../../../../reservation-selection'
import { editGuardState, invokeGuard } from '../../popup-edit-guard'

const TableView = 'table'
const CalendarView = 'calendar'

export default {
    components: { ReservationHistoryTable, ReservationHistoryCalendar },
    props: {
        hservice: Object,
        note: String,
        reservations: Array,
        selectedReservationID: String,
        isHistoryLoading: Boolean
    },
    data() {
        return {
            selectedType: TableView,
            editGuard: editGuardState,
        }
    },
    watch: {
        selectedType: {
            handler: function(newValue, oldValue) {
                if (newValue != oldValue) {
                    this.handleSetSelectedReservationID(undefined)
                }
            }
        }
    },
    computed: {
        isTable: function() {
            return this.selectedType == TableView
        },
        isCalendar: function() {
            return this.selectedType == CalendarView
        },
        isShowNewReservation: function() {
            if (sheetOverlays.isShowReservationPopup == true) { return false }
            return true
        },
        isSelectedReservation: function() {
            if (sheetOverlays.isShowReservationPopup == true) { return false }
            return (this.selectedReservationID ?? '') != ''
        },

        selectedReservation: function() {
            return this.reservations.find(r => r._id == this.selectedReservationID)
        }
    },
    methods: {
        action_Table() {
            this.selectedType = TableView
        },
        action_Calendar() {
            this.selectedType = CalendarView
        },
        action_SelectReservation() {
            let h = deepCopy(reservationSelection.selectedHService)
            let r = deepCopy(this.selectedReservation)

            closePopup()
            setTimeSelectMode(h, r)
        },
        async action_NewReservation() {
            if (this.editGuard.isEditBasicInfo) {
                let result = await invokeGuard('AlertEditUserBasicInfo')
                if (result == false) { 
                    closeAlertPopup()
                    return
                }
            }
            else if (this.editGuard.isUserNoteChanged) {
                await invokeGuard('AlertEditUserNote')
            }

            let h = deepCopy(reservationSelection.selectedHService)
            let r = {}

            closePopup()
            setTimeSelectMode(h, r)
        },

        handleSetSelectedReservationID(id) {
            this.$emit('setSelectedReservationID', id)
        },

        handleShowReservationChangeHistory() {
            this.$emit('showReservationChangeHistory')
        },

        handleHideReservationChangeHistory() {
            this.$emit('hideReservationChangeHistory')
        }
    }
}
</script>